/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faFileAlt,
  faBell,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  useLazyGetRestaurantDetailsByIdQuery,
  useLazyGetRestaurantsByOwnerIdQuery,
} from "../../redux/services/restaurantServices";
import Select from "react-select";
import { truncateText } from "../../utility/Utility";
import { Restaurant } from "../ReastaurantSlectModal";
import { toast } from "react-toastify";
import {
  openInitialSlectReastaurantModla,
  setSelectedRestaurantDetails,
} from "../../redux/restaurantsSlice";
import Swal from "sweetalert2";

import {
  clearNotificationById,
  clearNotifications,
} from "../../redux/notificationSlice";
import { RootState } from "../../redux/store";
import Logo from "../../assets/images/logoWOBGD.PNG";
import ManImage from "../../assets/icons/man.PNG";
// const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
// const logoSrc = `${IMAGE_BASE_URL}/assets/images/logoWOBGD.PNG`;
// const imageSrc = `${IMAGE_BASE_URL}/assets/icons/man.PNG`;

const getTimeAgo = (timestamp: number): string => {
  const now = Date.now();
  const difference = now - timestamp;

  const seconds = Math.floor(difference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return "now";
  if (minutes < 60) return `${minutes} minutes ago`;
  if (hours < 24) return `${hours} hours ago`;
  return `${days} days ago`;
};
const TopNavBar: React.FC = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const [clickedNotifications, setClickedNotifications] = useState<number[]>(
    []
  );

  const NotificationClick = (id: number, orderId: string) => {
    if (!clickedNotifications.includes(id)) {
      setClickedNotifications((prev) => [...prev, id]);
    }
    navigate("/orders/pickup-orders/view", { state: { orderId } });
  };

  const notifications = useSelector(
    (state: RootState) => state.notification.notifications
  );
  const unreadNotificationCount = notifications.filter(
    (notification) => !clickedNotifications.includes(notification.id)
  ).length;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const profileImageUrl = (location.state as any)?.profilePicture || "";
  const sortedNotifications = [...notifications].sort(
    (a, b) => b.timestamp - a.timestamp
  );

  const handleProfile = () => {
    if (isRestaurantSelected) {
      navigate("/profile");
    } else {
      toast.warning(
        "Please Create a restaurant to continue or create a restaurant from previous menu"
      );
    }
  };

  const isRestaurantSelected = useSelector(
    (state: any) => state.restaurant.isRestaurantSelected
  );

  const selectedRestaurantId =
    localStorage.getItem("selectedRestaurantId") || "";

  const selectedRestaurantIdFromRedux = useSelector(
    (state: any) => state.restaurant?.selectedRestaurantDetails?.id
  );

  const [trigger, { data: selectedRestaurantDetails, isLoading, error }] =
    useLazyGetRestaurantDetailsByIdQuery();

  const ownerId = localStorage.getItem("ownerID") || "";

  const [
    triggerAllRestaurant,
    {
      data: ownerRestaurants,
      isLoading: isOwnerRestaurantsLoading,
      error: isOwnerRestaurantsError,
    },
  ] = useLazyGetRestaurantsByOwnerIdQuery();

  // useEffect(() => {
  //   if (selectedRestaurantId) {
  //     trigger(selectedRestaurantId);
  //   }
  //   if (ownerId) {
  //     triggerAllRestaurant(ownerId);
  //   }
  // }, [selectedRestaurantId, trigger, ownerId, triggerAllRestaurant]);
  // change using redux

  useEffect(() => {
    if (selectedRestaurantIdFromRedux) {
      trigger(selectedRestaurantIdFromRedux);
    }
    if (ownerId) {
      triggerAllRestaurant(ownerId);
    }
  }, [selectedRestaurantIdFromRedux, trigger, ownerId, triggerAllRestaurant]);


  const restaurantList = ownerRestaurants?.restaurantList?.restaurants;

  const restaurantOptions = restaurantList?.map((restaurant: any) => ({
    value: restaurant.id,
    label: (
      <div className="d-flex gap-2 align-items-center">
        <img
          src={restaurant.imageUrl}
          alt={restaurant.displayName}
          style={{ width: 30, height: 30 }}
        />
        <div className="d-flex flex-column">
          <strong>{truncateText(restaurant.displayName, 20)}</strong>
          <small>{truncateText(restaurant.address, 20)}</small>
        </div>
      </div>
    ),
    isDisabled:
      restaurant.status === "Rejected" || restaurant.status === "Pending",
  }));

  const handleRestaurantChange = async (selectedOption: any) => {
    const newRestaurantId = selectedOption.value;

    const selectedRestaurant: Restaurant | undefined = restaurantList.find(
      (restaurant: Restaurant) => restaurant.id === newRestaurantId
    );

    if (!selectedRestaurant) {
      return;
    }

    const selectedRestaurantId = localStorage.getItem("selectedRestaurantId");
    if (!selectedRestaurant.id) {
      return;
    }
    // if (selectedRestaurantId === selectedRestaurant.id) {
    //   toast.warning("You are already logged in with this restaurant.");
    // } else {
    //   localStorage.setItem("selectedRestaurantId", selectedRestaurant.id || "");
    //   dispatch(openInitialSlectReastaurantModla(true));
    //   dispatch(setSelectedRestaurantDetails(selectedRestaurant));
    //   toast.success("You have successfully moved the login restaurant");
    // }
    if (selectedRestaurantIdFromRedux === selectedRestaurant.id) {
      toast.warning("You are already logged in with this restaurant.");
    } else {
      dispatch(openInitialSlectReastaurantModla(true));
      dispatch(setSelectedRestaurantDetails(selectedRestaurant));
      toast.success("You have successfully moved the login restaurant");
    }

  };

  // const defaultSelectedRestaurant = restaurantOptions?.find(
  //   // (option: any) => option.value === selectedRestaurantIdFromRedux
  //   (option: any) => option.value ===selectedRestaurantId
  // );

  // chnage with using redux
  const defaultSelectedRestaurant = restaurantOptions?.find(
    (option: any) => option.value === selectedRestaurantIdFromRedux
  );


  const customStyles = {
    container: (provided: any) => ({
      ...provided,
      minWidth: "300px",
    }),
  };

  const handleNotificationClick = () => {
    setIsNotificationOpen((prev) => !prev);
  };

  const clearNotification = (id: any) => {
    dispatch(clearNotificationById(id));
  };

  const clearAllNotification = (id: any) => {
    dispatch(clearNotifications());
  };

  const handleLogOut = () => {
    Swal.fire({
      title: "Are you sure you want to log out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log out",
    }).then((result: any) => {
      if (result.isConfirmed) {
        localStorage.clear();
        dispatch(openInitialSlectReastaurantModla(false));
        dispatch(setSelectedRestaurantDetails(null));
        
        // Dispatch custom event to notify navigation of auth state change
        window.dispatchEvent(new CustomEvent('authStateChanged'));
        
        navigate("/sign-in");
      }
    });
  };

  return (
    <div className="navbarMainStyles">
      <div className="d-flex gap-5 justify-content-between">
       
        <img
          src={Logo}
          alt="Logo"
          className="navbarlogoStyles"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        />
        {isRestaurantSelected && (
          <Select
            options={restaurantOptions}
            placeholder="Select Restaurant"
            onChange={handleRestaurantChange}
            value={defaultSelectedRestaurant}
            defaultValue={defaultSelectedRestaurant}
            loadingMessage={() => "Loading Restaurants..."}
            noOptionsMessage={() =>
              isLoading ? "Loading Restaurants..." : "No Restaurants found"
            }
            isSearchable
            className="top-bar-selection"
          />
        )}
      </div>
      <div className="navbarIconStyleDiv">
        <FontAwesomeIcon icon={faPhone} className="navbarIconStyles" />
        <FontAwesomeIcon icon={faFileAlt} className="navbarIconStyles" />
        {/* <FontAwesomeIcon icon={faBell} className="navbarIconStyles"/> */}
        <div style={{ position: "relative" }}>
          <FontAwesomeIcon
            icon={faBell}
            className="navbarIconStyles"
            onClick={handleNotificationClick}
          />

          {unreadNotificationCount > 0 && (
            <span className="notificationBadge">
              {unreadNotificationCount}
            </span>
          )}

          {isNotificationOpen && (
            <div
              className="notificationPopup"
              style={{
                position: "absolute",
                top: "40px",
                right: "0",
                width: "500px",
                background: "white",
                border: "1px solid #ddd",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                zIndex: 1000,
                maxHeight: "400px",
                overflowY: "auto",
                padding: "10px",
              }}
            >
              <div style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>

                <strong>Notifications</strong>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    color: "blue",
                    cursor: "pointer",
                    fontSize: "0.85rem",
                    paddingLeft: "50%"
                  }}
                  onClick={clearAllNotification}
                >
                  Clear All
                </button>


              </div>
              {sortedNotifications.length > 0 ? (
                <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                  {sortedNotifications.map((notification) => (
                    <li
                      key={notification.id}
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        backgroundColor: clickedNotifications.includes(
                          notification.id
                        )
                          ? "white"
                          : "#f0f0f0",
                      }}
                      onClick={() =>
                        NotificationClick(notification.id, notification.orderId)
                      }
                    >
                      <div>
                        <strong style={{ fontSize: "1rem" }}>
                          {notification.title} ({notification.orderId})
                        </strong>
                        <p style={{ fontSize: "0.85rem", color: "#666" }}>
                          {notification.body} (
                          {getTimeAgo(notification.timestamp)})
                        </p>
                      </div>
                      <button
                        style={{
                          background: "none",
                          border: "none",
                          color: "red",
                          cursor: "pointer",
                          fontSize: "1rem",
                          marginLeft: "auto",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          clearNotification(notification.id);
                        }}
                      >
                        ✖
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <div style={{ padding: "10px", textAlign: "center" }}>
                  No notifications
                </div>
              )}
            </div>
          )}
        </div>
        <div>
          <img
            className="avertaStyle"
            src={ManImage}
            alt="Login Cover"
            onClick={handleProfile}
          />
        </div>
        {!isRestaurantSelected && (
          <FontAwesomeIcon
            icon={faRightFromBracket}
            onClick={handleLogOut}
            className="navbarIconStyles"
          />
        )}
      </div>
    </div>
  );
};

export default TopNavBar;
